import { vendorAdapter } from './reducer'

export const { selectAll: selectAllVendors, selectById: selectVendorById } =
  vendorAdapter.getSelectors(state => state.vendors)
